// Mirrored in applications/platform-app/components/web-analytics — change both.
import React from 'react';
import { fmt, RUBY_TINT } from '../format';
import { Empty } from '../ui';

export interface BarRow { key: string; label: React.ReactNode; value: number; title?: string; onClick?: () => void }

/** Ranked rows with a tinted fill behind each one. Ported from the mockup's bars(). */
export const BarList: React.FC<{ rows: BarRow[]; format?: (v: number) => string; limit?: number; empty?: React.ReactNode; testId?: string; noFill?: boolean }> = ({ rows, format = fmt, limit = 6, empty, testId, noFill }) => {
  if (!rows.length) return <Empty>{empty}</Empty>;
  const mx = Math.max(...rows.map((r) => r.value)) || 1;
  return (
    <div data-testid={testId}>
      {rows.slice(0, limit).map((r) => {
        const Tag = r.onClick ? 'button' : 'div';
        return (
          <Tag
            key={r.key}
            {...(r.onClick ? { type: 'button' as const, onClick: r.onClick } : {})}
            title={r.title}
            className={`relative grid w-full text-left gap-2 items-center px-2 py-[7px] rounded-lg min-h-[44px] bg-transparent border-0 text-[13px] text-stone-900 ${r.onClick ? 'cursor-pointer hover:bg-stone-50' : ''}`}
            style={{ gridTemplateColumns: '1fr auto' }}
          >
            {!noFill && <div className="absolute left-0 top-[3px] bottom-[3px] rounded-md z-0" style={{ width: `${(r.value / mx) * 100}%`, background: RUBY_TINT }} />}
            <span className="relative z-[1] overflow-hidden text-ellipsis whitespace-nowrap">{r.label}</span>
            <b className="relative z-[1] font-semibold">{format(r.value)}</b>
          </Tag>
        );
      })}
    </div>
  );
};
